'use client';

import { cn } from '@/lib/utils';
import type { JobPagination } from '@/services/jobs/model';
import {
  JobResultsViewToggle,
  type JobResultsViewMode,
} from './job-results-view-toggle';

type JobResultsHeadingProps = {
  isSplitView: boolean;
  onViewModeChange: (viewMode: JobResultsViewMode) => void;
  pagination: JobPagination;
  searchLocations: string[];
  searchQuery: string;
  viewMode: JobResultsViewMode;
};

export function JobResultsHeading({
  isSplitView,
  onViewModeChange,
  pagination,
  searchLocations,
  searchQuery,
  viewMode,
}: JobResultsHeadingProps) {
  const normalizedQuery = searchQuery.trim();
  const locationText = searchLocations.join(', ');
  const headingLocation = searchLocations.length === 1 ? locationText : '';
  const titleSuffix =
    normalizedQuery || headingLocation
      ? `${normalizedQuery ? ` ${normalizedQuery}` : ''}${headingLocation ? ` tại ${headingLocation}` : ''}`
      : ' mới nhất';
  const formattedTotal = pagination.total.toLocaleString('vi-VN');

  return (
    <div
      className={cn(
        'mb-4 flex min-w-0 items-end justify-between gap-4',
        isSplitView && 'sm:mb-5'
      )}
    >
      <div className="flex min-w-0 items-start">
        <div className="font-body min-w-0">
          <h1 className="font-body text-ui-base leading-5 font-normal text-black sm:hidden">
            Có{' '}
            <strong className="text-primary font-bold">{formattedTotal}</strong>{' '}
            việc làm
            {normalizedQuery || searchLocations.length ? '' : ' mới nhất'}
          </h1>

          <h1 className="font-body text-content-strong text-ui-base hidden font-medium sm:inline">
            Tuyển dụng{' '}
            <strong className="text-primary font-medium">
              {formattedTotal}
            </strong>{' '}
            việc làm{titleSuffix}
          </h1>
        </div>
      </div>
      {!isSplitView ? (
        <div className="hidden sm:block">
          <JobResultsViewToggle
            value={viewMode}
            onValueChange={onViewModeChange}
          />
        </div>
      ) : null}
    </div>
  );
}
